<template>
  <h2 class="order-table-item-title">
    <template v-if="!url">
      {{ text }}
    </template>

    <nuxt-link
      v-else
      :data-tealium-rel="slugify(tealiumRel)"
      :to="url"
      class="order-table-item-title__link"
    >
      {{ text }}
    </nuxt-link>
  </h2>
</template>

<script>
import { slugify } from '@i22-td-smarthome/component-library';

export default {
  name: 'OrderTableItemTitle',
  methods: { slugify },
  props: {
    text: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: false,
      default: null,
    },
  },
  computed: {
    tealiumRel() {
      return `content.text.${this.text}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;
.order-table-item-title {
  @include font-size(18px, 27px);
  margin: 0 0 $grid-base;

  &__link {
    color: var(--color-font);
    text-decoration: none;

    &:link,
    &:active,
    &:visited,
    &:hover,
    &:focus {
      color: var(--color-font);
    }
  }
}
</style>
